$(document).ajaxSend(function () {
  if (window.ajax_start_timestamps == null) {
    window.ajax_start_timestamps = [];
  }
  window.ajax_start_timestamps.push(Date.now() / 1000);
});
